// extracted by mini-css-extract-plugin
export var auto = "_3s-1";
export var spinner = "_3s-0";